require('bootstrap/dist/css/bootstrap.min.css')
require('./src/styles/bootstrap-overrides.scss')
require('./src/styles/builder-overrides.scss')
require('./src/styles/global.scss')

const maxmind = require('./src/components/maxmind')

exports.onInitialClientRender = () => maxmind()

exports.onRouteUpdate = ({ location }) => {
    window.dispatchEvent(new Event('NAVIGATE'))
    const { hash } = location
    const el = hash ? document.querySelector(hash) : null
    if (el) window.requestAnimationFrame(() => window.scrollTo(0, el.offsetTop))
}

exports.shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition, }) => {
    const savedScrollPosition = getSavedScrollPosition(location)
    window.requestAnimationFrame(() => window.scrollTo(...savedScrollPosition))
    return false
}
